import { render, staticRenderFns } from "./AftermarketApprove.vue?vue&type=template&id=59d1c176&scoped=true&"
import script from "./AftermarketApprove.vue?vue&type=script&lang=js&"
export * from "./AftermarketApprove.vue?vue&type=script&lang=js&"
import style0 from "./AftermarketApprove.vue?vue&type=style&index=0&id=59d1c176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d1c176",
  null
  
)

export default component.exports